import styled from "styled-components";
import { TICK_ACCENT } from "../Tick";

interface TickStyleProps {
    $selected: boolean;
    $accent: TICK_ACCENT;
}

export const Tick = styled.div`
    width: 20px;
    outline: 0;
`;

export const TickContainer = styled.div<TickStyleProps>(({ theme, $selected, $accent }) => ({
    width: "20px",
    height: "20px",
    borderRadius: theme.cornerRadius.rounded,
    textAlign: "center",
    transition: "all 0.3s ease",
    float: "right",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    ...(!$selected && {
        border: `solid 1.5px ${theme.colors[theme.colorMode].border_Secondary}`,
        backgroundColor: theme.colors[theme.colorMode].background_Primary,
    }),

    ...($selected && {
        color: theme.colors[theme.colorMode].background_Primary,
        ...($accent === TICK_ACCENT.GREEN && {
            borderColor: theme.colors[theme.colorMode].special_positive,
            backgroundColor: theme.colors[theme.colorMode].special_positive,
        }),
        ...($accent === TICK_ACCENT.ORANGE && {
            borderColor: theme.colors[theme.colorMode].primary,
            backgroundColor: theme.colors[theme.colorMode].primary,
        }),
    }),
}));

export const TickIcon = styled.span`
    font-size: 16px;
`;

export const TickSvg = styled.svg`
    font-size: 16px;
`;
